import { WWW_URL, clientEnvironmentOf } from '@lark-automadoc/shared-types'

/**
 * Origin for `docsUrl()` / `docsGettingStartedUrl()`, resolved per environment.
 *
 * Read here rather than inside a shared package. shared-types is imported by the
 * Workers, where `import.meta.env` does not exist; shared-ui is typechecked by
 * its own `vue-tsc` run without Vite's client types, so reaching for
 * `import.meta.env` there fails the build — the same reason PricingCards takes a
 * `showQuarterly` prop instead of reading its env. Hence one of these per app.
 *
 * Empty falls back to the production docs, so an unset variable degrades to a
 * working link.
 */
export const DOCS_ORIGIN = import.meta.env.VITE_DOCS_URL

/**
 * Marketing site origin, which hosts the legal policies this app links to.
 *
 * Falls back to production so a build without the variable still reaches real
 * policies — Paddle's domain review has to load them. The fallback comes from
 * shared-types rather than a literal here, for the same reason www's portal
 * link does: one place to change the host.
 */
export const WWW_ORIGIN = import.meta.env.VITE_WWW_URL || WWW_URL

/**
 * Which store listings apply (shared-types CLIENT_STORE_LINKS). Only a production
 * build is production: a staging or local build must never send someone to a
 * production listing whose app talks to the production API.
 */
export const CLIENT_ENVIRONMENT = clientEnvironmentOf(import.meta.env.MODE)

/**
 * This environment's API, for addresses a person copies into another product (the
 * Power Platform connector definition). The dev server proxies `/api` on its own origin.
 */
export const API_ORIGIN = import.meta.env.VITE_API_URL || window.location.origin
